module.exports = __webpack_public_path__ + "static/media/peda_cover_page.949a266e.gif";